module.exports = __webpack_public_path__ + "img/phone-grey.72ad6b0c.png";